/* ================================================
   A11Y PATCH v2 — aria-label + alt + roles
   SuperNutriOmni — aplicado em: 11/06/2025
================================================ */
(function () {
  function setIfMissing(el, attr, value) {
    if (!el) return;
    var cur = el.getAttribute(attr);
    if (!cur || !cur.trim()) el.setAttribute(attr, value);
  }

  function hasAccessibleName(el) {
    if (!el) return false;
    var aria = el.getAttribute('aria-label');
    if (aria && aria.trim()) return true;
    var txt = (el.textContent || '').trim();
    return txt.length > 0;
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else fn();
  }

  ready(function () {

    /* 1) Botão Global / idioma */
    document.querySelectorAll('button.js-intl-toggle, .js-intl-toggle').forEach(function (btn) {
      setIfMissing(btn, 'aria-label', 'Selecionar idioma / país');
      setIfMissing(btn, 'title', 'Selecionar idioma / país');
    });

    /* 2) Botão menu mobile (hamburger) */
    document.querySelectorAll('[data-action="toggle-menu"]').forEach(function (btn) {
      setIfMissing(btn, 'aria-label', 'Abrir menu de navegação');
    });

    /* 3) Botão busca (lupa) */
    document.querySelectorAll('[data-action="toggle-search"], .search-bar__submit').forEach(function (btn) {
      setIfMissing(btn, 'aria-label', 'Buscar produtos');
    });

    /* 4) Botão carrinho */
    document.querySelectorAll('.header__cart-toggle, [data-action="toggle-mini-cart"]').forEach(function (a) {
      setIfMissing(a, 'aria-label', 'Abrir carrinho de compras');
    });

    /* 5) Botão fechar (ícone ×) sem texto visível */
    document.querySelectorAll('.search-bar__input-clear, .intl-close, [data-action="unfix-search"]').forEach(function (btn) {
      setIfMissing(btn, 'aria-label', 'Fechar');
    });

    /* 6) Slideshow: links + imagens sem alt */
    document.querySelectorAll('a.slideshow__slide, a[id^="block-"].slideshow__slide').forEach(function (a) {
      if (!hasAccessibleName(a)) {
        var img = a.querySelector('img');
        var alt = img && (img.getAttribute('alt') || '').trim();
        setIfMissing(a, 'aria-label', alt || 'Abrir banner');
      }
    });
    document.querySelectorAll('img.slideshow__image').forEach(function (img) {
      var alt = (img.getAttribute('alt') || '').trim();
      if (!alt) {
        var slide = img.closest('a');
        var label = slide && (slide.getAttribute('aria-label') || slide.getAttribute('title'));
        img.setAttribute('alt', (label && label.trim()) ? label.trim() : 'Banner');
      }
    });

    /* 7) Grade de produtos: links sem aria-label */
    document.querySelectorAll('a.product-item__vendor, a.product-item__title').forEach(function (a) {
      if (!a.getAttribute('aria-label')) {
        var t = (a.textContent || '').trim();
        if (t) a.setAttribute('aria-label', t);
      }
    });

    /* 8) Imagens de produtos sem alt */
    document.querySelectorAll('.product-item__primary-image, .product-item__secondary-image').forEach(function (img) {
      var alt = (img.getAttribute('alt') || '').trim();
      if (!alt) {
        var item = img.closest('.product-item');
        var title = item && item.querySelector('.product-item__title');
        img.setAttribute('alt', title ? (title.textContent || '').trim() : 'Imagem do produto');
      }
    });

    /* 9) Imagens de coleção sem alt */
    document.querySelectorAll('.collection-item img').forEach(function (img) {
      var alt = (img.getAttribute('alt') || '').trim();
      if (!alt) {
        var item = img.closest('.collection-item');
        var title = item && item.querySelector('.collection-item__title');
        img.setAttribute('alt', title ? (title.textContent || '').trim() : 'Imagem da coleção');
      }
    });

    /* 10) WhatsApp flutuante */
    document.querySelectorAll('a.btn--whatsapp, a[href*="wa.me"]').forEach(function (a) {
      setIfMissing(a, 'aria-label', 'Falar no WhatsApp');
      setIfMissing(a, 'title', 'Falar no WhatsApp');
    });

    /* 11) Inputs de busca sem placeholder visível */
    document.querySelectorAll('input[type="search"], input.search-bar__input').forEach(function (inp) {
      setIfMissing(inp, 'aria-label', 'Buscar produtos');
    });

    /* 12) Botões de fechar popover/modal */
    document.querySelectorAll('[data-action="close-modal"], [data-action="close-popover"]').forEach(function (btn) {
      setIfMissing(btn, 'aria-label', 'Fechar');
    });

    /* 13) Logo da loja */
    document.querySelectorAll('.header__logo-link').forEach(function (a) {
      setIfMissing(a, 'aria-label', 'SuperNutriOmni — página inicial');
    });

    /* 14) Links de paginação */
    document.querySelectorAll('.pagination a[href]').forEach(function (a) {
      if (!hasAccessibleName(a)) {
        setIfMissing(a, 'aria-label', 'Ir para página ' + (a.textContent || '').trim());
      }
    });

  });

  /* 15) Observar injeções dinâmicas (mini-cart, quick-view) */
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          node.querySelectorAll && node.querySelectorAll('a[href*="wa.me"]').forEach(function (a) {
            setIfMissing(a, 'aria-label', 'Falar no WhatsApp');
          });
          node.querySelectorAll && node.querySelectorAll('.product-item__primary-image').forEach(function (img) {
            var alt = (img.getAttribute('alt') || '').trim();
            if (!alt) img.setAttribute('alt', 'Imagem do produto');
          });
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

})();
